import current from './current'

/**
 * ユーザー
 */
export default {
  namespaced: true,
  modules: {
    current,
  },
}
